module.exports = __webpack_public_path__ + "static/media/icn-nav-search.f6326dcd.svg";